export default __webpack_public_path__ + "static/media/notification.0974f355.svg";